import {
  Theme, styled, Typography, Box
} from '@mui/material'

import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro'
import React from 'react'
import { useTranslation } from 'react-i18next'

const StyledDataGrid = styled(DataGridPro)(({ theme }: { theme?: Theme }) => ({
  border: `1px solid ${(theme?.palette.primary as any)[200]}`,
  overflow: 'hidden',
  color: theme?.palette.text.primary,
  '& .MuiDataGrid-columnHeaderWrapper, & .MuiDataGrid-columnsContainer': {
    maxHeight: '38px !important',
    minHeight: '38px !important',
    lineHeight: '38px !important'
  },
  '& .MuiDataGrid-renderingZone': {
    maxHeight: 'none !important'
  },
  '& .MuiDataGrid-cell[data-field=user_name_with_image_and_email]': {
    justifyContent: 'flex-start !important'
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid  ${(theme?.palette.primary as any)[200]}`,
    borderBottomColor: `${(theme?.palette.primary as any)[200]} !important`,
    backgroundColor: 'background.paper',
    color: theme?.palette.text.primary,
    fontSize: '12px'
    // lineHeight: 'unset !important',
    // display: 'flex !important',
    // // justifyContent: 'center !important',
    // alignItems: 'center !important',
    // whiteSpace: 'normal',
    // textAlign: 'left'
  },
  '& .MuiDataGrid-row': {
    maxHeight: 'none !important',
    borderColor: '#79BBFC !important',
    outline: 'none !important'
  },
  '& .MuiDataGrid-viewport': {
    maxHeight: 'none !important',
    backgroundColor: 'background.paper'
  },
  '& .MuiDataGrid-window': {
    height: 'unset !important',
    position: 'relative !important',
    top: '38px !important'
  },
  '& .MuiDataGrid-windowContainer': {
    height: 'unset !important',
    position: 'relative !important',
    paddingBottom: '38px'
  },
  '& .MuiDataGrid-columnsContainer': {
    zIndex: '100'
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme?.palette.primary.main,
    color: 'white'

  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: 'none !important',
    fontSize: '12px'
  },
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'hidden'
  },
  // '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
  //   borderRight: `1px solid ${
  //     theme?.palette.mode === 'light' ? '#f0f0f0' : '#303030'
  //   }`
  // },
  '& .MuiDataGrid-window::-webkit-scrollbar,.MuiDataGrid-virtualScroller::-webkit-scrollbar ':
    {
      display: 'none'
    },
  '& .MuiInputBase-input': {
    textAlign: 'center'
  }
}))

const StyledXGrid: ReactFC<DataGridProProps> = ({ components, ...props }) => {
  const { t } = useTranslation()
  return (
    <StyledDataGrid
      components={{
        NoRowsOverlay: () => (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'grid',
              placeItems: 'center'
            }}
          >
            <Typography>{t('texts.No_data_available')}</Typography>
          </Box>
        ),
        ...components
      }}
      {...props}
    />
  )
}
export default StyledXGrid
